export default __webpack_public_path__ + "d4fbc11053ff3d14fcc372c38d6ad861.svg";